import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Resolve } from '@angular/router';
import { Page } from 'src/app/core/models/Page';

@Injectable()
export class EmbargoListService implements Resolve<any> {

  page: Page = new Page();

  constructor(
    private http: HttpClient
  ) {
    this.page.size = 100;
    this.page.pageNumber = 0;
    this.page.state = 1;
    this.page.types = 0;
  }

  resolve(): Observable<any> {
    return this.getSojList(this.page);
  }

  getSoj(page): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getSojList(page).subscribe(res => {
        resolve(res);
      }, reject);
    });
  }

  getSojList(page): Observable<any> {
    const httpParams = new HttpParams({
      fromObject: page
    });
    return this.http.get<any>(`${environment.BACKEND}oficio/list`, {
      params: httpParams
    });
  }

  updateSoj(values): Observable<any> {
    return this.http.put(`${environment.BACKEND}oficio/request/create`, values);
  }

  deleteSoj(values): Observable<any> {
    const motivo = {headers: new HttpHeaders({}), body: {details: values.details, nroLiquidacion: values.NRO_LIQUIDACION}};
    return this.http.delete(`${environment.BACKEND}embargo/${values.id_oficio}`, motivo);
  }

  goDescargarArchivoAFIP(): Observable<any> {
    return this.http.get(`${environment.BACKEND}oficio/download`, { responseType: 'blob' });
  }

  getCancelMotives(): Observable<any> {
    const request = {headers: new HttpHeaders({}) };
    return this.http.get(`${environment.BACKEND}oficio/cancel-motives`, request);
  }

  downloadCSV(page): Observable<any> {
    const httpParams = new HttpParams({
      fromObject: page
    });
    return this.http.get(`${environment.BACKEND}oficio/downloadlist`, {
      params: httpParams
    });
  }

  cancelOtax(values): Observable<any> {
    return this.http.post(`${environment.BACKEND}otax/baja/liquidacion`, values);
  }

  getTypesSoj(): Observable<any> {
    return this.http.get(`${environment.BACKEND}oficio/list_tipo_soj`);
  }
}
